import { render, staticRenderFns } from "./UserVessels.vue?vue&type=template&id=6a913235&scoped=true&"
import script from "./UserVessels.vue?vue&type=script&lang=js&"
export * from "./UserVessels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a913235",
  null
  
)

export default component.exports